import {
    ConfirmationModal,
    DialogModal,
    DrawerModal,
    FloaterModals,
    FloatingRoomModal,
    GridStateX,
    HealthStateX,
    MenuStateX,
    ModalStack,
    QuickMenuModal,
    RoomsState,
    ScreenStateX,
    UsersStateX,
    VideoStateX,
} from '../../types/mfc'
import { NOOP } from '../constants'
import {
    FloaterPageState,
    FloaterSize,
    ModalKind,
    RoomView,
} from '../constants/enums'
import { FLOATING_ROOM } from '../constants/floaters'

export const GRID_STATE: { grid: GridStateX } = {
    grid: {
        avatarInfoOpenID: null,
        centeredIndex: null,
        scrollOffset: null,
    },
}

export const HEALTH_STATE: { health: HealthStateX } = {
    health: {
        connecting: true,
        connected: false,
        paused: null,
        status: null,
        error: null,
    },
}

export const MENU_STATE: { menu: MenuStateX } = {
    menu: {
        persist: {
            mute: true,
        },
        id: null,
    },
}

export const ROOMSSTATE: RoomsState = {
    pinnedRooms: [],
    pinHelperID: 0,
    restored: 0,
    rooms: {},
}

export const SCREEN_STATE: { screen: ScreenStateX } = {
    screen: {
        calculated: false,
        contentHeight: undefined,
        contentWidth: undefined,
        hasPinnedRooms: false,
        orientationType: FloaterPageState.PORTRAIT,
        pinLimit: 1,
        pinLimitReached: false,
        pinsHeight: undefined,
        pinsWidth: undefined,
        portrait: true,
        ratio: 0.5,
        roomHeight: undefined,
        roomWidth: undefined,
        roomX: 0,
        roomY: 0,
        singlePin: false,
        windowHeight: undefined,
        windowWidth: undefined,
    },
}

export const USERS_STATE: { users: UsersStateX } = {
    users: {
        modelsRequested: false,
        modelsLoaded: false,
    },
}

export const VIDEO_STATE: { video: VideoStateX } = {
    video: {
        volume: 0.5,
        mute: false,
    },
}

export type ModalState = {
    [ModalKind.Confirmation]: ConfirmationModal
    [ModalKind.Dialog]: DialogModal
    [ModalKind.Drawer]: DrawerModal
    [ModalKind.Floater]: FloaterModals
    [ModalKind.FloatingRoom]: FloatingRoomModal
    [ModalKind.QuickMenu]: QuickMenuModal
}

export const MODAL_STATE: ModalState = {
    [ModalKind.Dialog]: { type: NOOP, show: false },
    [ModalKind.Drawer]: { type: NOOP, show: false },
    [ModalKind.Confirmation]: { show: false },
    [ModalKind.QuickMenu]: { show: false } as QuickMenuModal,
    [ModalKind.Floater]: {
        /// Multi Modal, keyed by `${id}-${QUICK_REPLY}` or other floater constants
    },
    [ModalKind.FloatingRoom]: {
        id: null,
        type: FLOATING_ROOM,
        show: false,
        expanded: true,
        minimized: false,
        size: FloaterSize.Fullscreen,
        roomView: RoomView.Room,
        locations: {
            portrait: null,
            landscape: null,
        },
    },
}

export const MODAL_STACK: ModalStack = {
    byPosition: [],
    byKey: {},
}

export const getState = () => ({
    GRIDSTATE: GRID_STATE.grid,
    HEALTHSTATE: HEALTH_STATE.health,
    MENUSTATE: MENU_STATE.menu,
    ROOMSSTATE,
    SCREENSTATE: SCREEN_STATE.screen,
    USERSSTATE: USERS_STATE.users,
    VIDEOSTATE: VIDEO_STATE.video,
    MODALSTATE: MODAL_STATE,
    MODALSTACKSTATE: MODAL_STACK,
})

type StateAction<
    T,
    O extends Record<string, unknown> = Record<string, unknown>,
> = (updates: Partial<T>, options: O) => void

export const customStateWrapper =
    <T, O extends Record<string, unknown> = Record<string, unknown>>(
        stateEmitter: StateAction<T, O>,
    ) =>
    (stateSetter: StateAction<T, O>) =>
    (updates: Partial<T>, options?: O): void => {
        const opts = options ?? ({} as O)
        stateSetter(updates, opts)
        stateEmitter(updates, opts)
    }
